import React from 'react';

import { Collapse, IconButton, Typography } from '@mui/material';
import { useLocalStorage } from 'react-use';
import { AnimatedArrowIcon, RecentDocumentsList, Spacer } from 'src/components';
import type { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  header: {
    alignItems: 'center',
    display: 'flex',
  },
  section: {
    backgroundColor: theme.appColors.darkBackground,
    borderRadius: 3,
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1),
  },
}));

interface MyRecentDocumentsProps {
  docVariant: Apollo.DocumentVariant;
}

export const myRecentDocumentsKey = 'MyRecentDocuments.expanded';
export function MyRecentDocuments({ docVariant }: MyRecentDocumentsProps): JSX.Element {
  const { classes } = useStyles();
  const [expanded = true, setExpanded] = useLocalStorage<boolean>(myRecentDocumentsKey, true);

  return (
    <div className={classes.section}>
      <div className={classes.header}>
        <Typography variant="subtitle1">My Recent Activity</Typography>
        <Spacer />
        <IconButton size="small" onClick={() => setExpanded(!expanded)}>
          <AnimatedArrowIcon rotated={expanded} />
        </IconButton>
      </div>
      <Collapse in={expanded}>
        <RecentDocumentsList docVariant={docVariant} />
      </Collapse>
    </div>
  );
}
